import {Component} from '@angular/core';
import {UrlService} from '../../../services/url.service';
import {SettingsDirectoryService} from '../../../services/settings-directory.service';

declare const toastr: any;
declare const $: any;

@Component({
    selector: 'corporations-list',
    templateUrl: './corporations-list.component.html',
    styleUrls: ['./corporations-list.component.scss']
})
export class CorporationsListComponent {

    constructor(
        public urlService: UrlService,
        public settingsDirectoryService: SettingsDirectoryService
    ) {}

    orderBy(orderBy: string, $event) {
        if (this.settingsDirectoryService.data.corporations.total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    toggleCheck(selectedItem): void {
        const checked = selectedItem.checked;
        this.uncheckItem();
        if (checked && this.settingsDirectoryService.selectedItemData) {
            this.settingsDirectoryService.chosenCorporation = null;
            this.settingsDirectoryService.toggleDetailedView(null, false);
            selectedItem.checked = false;
        } else {
            this.settingsDirectoryService.chosenCorporation = selectedItem;
            selectedItem.checked = true;
            //get website builder settings for corporation before toogling
            this.settingsDirectoryService.toggleDetailedView(selectedItem, true);
        }
    }

    uncheckItem(): void {
        this.settingsDirectoryService.data.corporations.data.forEach((item) => item.checked = false);
    }

    showHint(e) {
        e.stopPropagation();
        const $td = $(e.target).closest('.table-hint-td');
        if ($td.hasClass('active'))
            $td.removeClass('active');
        else {
            $('.table-hint-td').removeClass('active');
            $td.addClass('active');
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-directory/corporations-list/corporations-list.component.ts